import { isObject } from '@pct-ts/typeguard';
import type { ToastMessageOptions } from './message-options';

export function isToastMessageOptions(msg: unknown): msg is ToastMessageOptions {
  return isObject(msg) && 'type' in msg && msg.type === 'TOAST';
}
